// Store
import * as Actions from '../../../store/bulk/void/bulk.void.actions';

export const ShowVoidConfirmationStep = (state, jobId) => {
  return [Actions.showBulkVoidConfirmation(jobId)];
};
